import script from "./Informacion.vue?vue&type=script&setup=true&lang=js"
export * from "./Informacion.vue?vue&type=script&setup=true&lang=js"

import "./Informacion.vue?vue&type=style&index=0&id=860b9ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-860b9ae2"]])

export default __exports__